var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$currentUserCan(_vm.$permissions.PERM_VIEW_ANY_RESELLERS) && _vm.reseller)?_c('div',[_c('object-link',{attrs:{"object":_vm.reseller}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }